import { __extends } from "tslib";
import { Observable } from './Observable';
import { Subscription } from './Subscription';
var Subject = (function (_super) {
    __extends(Subject, _super);
    function Subject() {
        var _this = _super.call(this) || this;
        _this._closed = false;
        _this._observerCounter = 0;
        _this.currentObservers = new Map();
        _this.hasError = false;
        _this.thrownError = null;
        return _this;
    }
    Object.defineProperty(Subject.prototype, "closed", {
        get: function () {
            return this._closed;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Subject.prototype, "observers", {
        get: function () {
            var _a;
            return ((_a = this.observerSnapshot) !== null && _a !== void 0 ? _a : (this.observerSnapshot = Array.from(this.currentObservers.values())));
        },
        enumerable: false,
        configurable: true
    });
    Subject.prototype._clearObservers = function () {
        this.currentObservers.clear();
        this.observerSnapshot = undefined;
    };
    Subject.prototype.next = function (value) {
        if (!this._closed) {
            var observers = this.observers;
            var len = observers.length;
            for (var i = 0; i < len; i++) {
                observers[i].next(value);
            }
        }
    };
    Subject.prototype.error = function (err) {
        if (!this._closed) {
            this.hasError = this._closed = true;
            this.thrownError = err;
            var observers = this.observers;
            var len = observers.length;
            for (var i = 0; i < len; i++) {
                observers[i].error(err);
            }
            this._clearObservers();
        }
    };
    Subject.prototype.complete = function () {
        if (!this._closed) {
            this._closed = true;
            var observers = this.observers;
            var len = observers.length;
            for (var i = 0; i < len; i++) {
                observers[i].complete();
            }
            this._clearObservers();
        }
    };
    Subject.prototype.unsubscribe = function () {
        this._closed = true;
        this._clearObservers();
    };
    Object.defineProperty(Subject.prototype, "observed", {
        get: function () {
            return this.currentObservers.size > 0;
        },
        enumerable: false,
        configurable: true
    });
    Subject.prototype._subscribe = function (subscriber) {
        this._checkFinalizedStatuses(subscriber);
        return this._innerSubscribe(subscriber);
    };
    Subject.prototype._innerSubscribe = function (subscriber) {
        var _this = this;
        if (this.hasError || this._closed) {
            return Subscription.EMPTY;
        }
        var currentObservers = this.currentObservers;
        var observerId = this._observerCounter++;
        currentObservers.set(observerId, subscriber);
        this.observerSnapshot = undefined;
        subscriber.add(function () {
            currentObservers.delete(observerId);
            _this.observerSnapshot = undefined;
        });
        return subscriber;
    };
    Subject.prototype._checkFinalizedStatuses = function (subscriber) {
        var _a = this, hasError = _a.hasError, thrownError = _a.thrownError, _closed = _a._closed;
        if (hasError) {
            subscriber.error(thrownError);
        }
        else if (_closed) {
            subscriber.complete();
        }
    };
    Subject.prototype.asObservable = function () {
        var _this = this;
        return new Observable(function (subscriber) { return _this.subscribe(subscriber); });
    };
    Subject.create = function (destination, source) {
        return new AnonymousSubject(destination, source);
    };
    return Subject;
}(Observable));
export { Subject };
var AnonymousSubject = (function (_super) {
    __extends(AnonymousSubject, _super);
    function AnonymousSubject(destination, _source) {
        var _this = _super.call(this) || this;
        _this.destination = destination;
        _this._source = _source;
        return _this;
    }
    AnonymousSubject.prototype.next = function (value) {
        var _a, _b;
        (_b = (_a = this.destination) === null || _a === void 0 ? void 0 : _a.next) === null || _b === void 0 ? void 0 : _b.call(_a, value);
    };
    AnonymousSubject.prototype.error = function (err) {
        var _a, _b;
        (_b = (_a = this.destination) === null || _a === void 0 ? void 0 : _a.error) === null || _b === void 0 ? void 0 : _b.call(_a, err);
    };
    AnonymousSubject.prototype.complete = function () {
        var _a, _b;
        (_b = (_a = this.destination) === null || _a === void 0 ? void 0 : _a.complete) === null || _b === void 0 ? void 0 : _b.call(_a);
    };
    AnonymousSubject.prototype._subscribe = function (subscriber) {
        var _a, _b;
        return (_b = (_a = this._source) === null || _a === void 0 ? void 0 : _a.subscribe(subscriber)) !== null && _b !== void 0 ? _b : Subscription.EMPTY;
    };
    return AnonymousSubject;
}(Subject));
export { AnonymousSubject };
//# sourceMappingURL=Subject.js.map